import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function FoundingCounter({ inline = false }) {
    const { t } = useI18n();
    const [data, setData] = useState({ goal: 50000, claimed: 0, remaining: 50000, progress_pct: 0 });

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                const res = await api.get("/members/counter");
                if (mounted) setData(res.data);
            } catch { /* silent */ }
        };
        // Defer the initial fetch + polling to idle so the counter never
        // competes with LCP/FCP. The card renders with default placeholders
        // (0 of 50,000) for the first ~1s, then populates from the API.
        const ric = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
        let intervalId = null;
        const handle = ric(() => {
            load();
            intervalId = setInterval(load, 15000);
        }, { timeout: 3000 });
        return () => {
            mounted = false;
            if (intervalId) clearInterval(intervalId);
            if (window.cancelIdleCallback) window.cancelIdleCallback(handle);
        };
    }, []);

    const pct = Math.max(0.5, data.progress_pct);

    if (inline) {
        return (
            <div className="text-sm text-white/80" data-testid="founding-counter-inline">
                <span className="text-[#D4AF37] font-semibold">{data.claimed.toLocaleString()}</span> {t("counter.of") || "of"} {data.goal.toLocaleString()} {t("counter.claimed")}
            </div>
        );
    }

    return (
        <div className="bg-white/5 border border-[#D4AF37]/30 rounded-sm p-5 backdrop-blur" data-testid="founding-counter">
            <div className="flex items-center justify-between mb-2">
                <div className="eyebrow text-[#D4AF37]">{t("counter.title")}</div>
                <div className="eyebrow text-white/60">{t("counter.limit")}</div>
            </div>
            <div className="flex items-end gap-2 text-white">
                <div className="font-heading text-4xl sm:text-5xl font-black tracking-tight">{data.claimed.toLocaleString()}</div>
                <div className="pb-1 text-white/60 text-sm">/ {data.goal.toLocaleString()} {t("counter.claimed")}</div>
            </div>
            <div className="mt-4 h-2 bg-white/10 rounded-sm overflow-hidden">
                <div className="h-full bg-gradient-to-r from-[#9B1B30] via-[#D4AF37] to-[#9B1B30]" style={{ width: `${pct}%` }} />
            </div>
            <div className="mt-3 flex justify-between text-xs text-white/70">
                <span data-testid="founding-remaining">{data.remaining.toLocaleString()} {t("counter.remaining")}</span>
                <span className="text-[#D4AF37]">{t("counter.lock")}</span>
            </div>
        </div>
    );
}
